<template>
  <div class="popup_content">
    <div class="back" style="position: relative;">
      <img src="@/assets/topback.png" alt="" width="100%" style="display: block;">
      <div style="position: absolute;text-align: center;top: 20%;left: 0;right: 0;">
        <img src="@/assets/logo.png" alt="" width="28%" style="z-index:999;">
      </div>
      <!-- 实时时间戳，防止静态图片伪造 -->
      <div style="position: fixed;top: 10px;left: 10px;color: #fff;font-size: 14px;background: rgba(0,0,0,0.3);padding: 3px 8px;border-radius: 4px;z-index:9999;">
        {{ currentTime }}
      </div>
    </div>
    <div class="progress_all" v-if="!loading">
      <CellGroup style="position:relative;margin-bottom: 10px;" inset class="progress_popup" v-for="(item, index) in items" :data-record-id="item.id">
        <!-- 状态标签 -->
        <div class="status_tip" style='background:#f0861d' v-if="item.approval_status == 3 || (item.approval_status == 1 && item.s_approval_status == 3)">审批中</div>
        <div class="status_tip" style='background:#e62525' v-else-if="item.approval_status == 2 || item.s_approval_status == 2">已驳回</div>
        <div class="status_tip" style='background:#b4b6bd'  v-else-if="item.approval_status == 1 && item.s_approval_status == 1 && item.offshelves_time*1000 < new Date().getTime">已过期</div>
        <div class="status_tip" style='background:#3370ff' v-else-if="item.approval_status == 1 && item.s_approval_status == 1">正常</div>
        <!-- 篡改警告 -->
        <div class="status_tip" style='background:#ff0000; left:0; border-radius:8px 0;' v-if="item._tampered">数据异常</div>
        
        <!-- 9个独立水印元素，均匀分布 -->
        <div class="watermark watermark-top-left">{{ item.id }}</div>
        <!-- <div class="watermark watermark-top-center">{{ item.id }}</div> -->
        <div class="watermark watermark-top-right">{{ item.id }}</div>
        <div class="watermark watermark-middle-left">{{ item.id }}</div>
        <div class="watermark watermark-center">{{ item.id }}</div>
        <div class="watermark watermark-middle-right">{{ item.id }}</div>
        <div class="watermark watermark-bottom-left">{{ item.id }}</div>
        <!-- <div class="watermark watermark-bottom-center">{{ item.id }}</div> -->
        <!-- <div class="watermark watermark-bottom-right">{{ item.id }}</div> -->
        
        <div style="padding:10px;">
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">申请人</span>
            <span>{{item.username}}</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">身份证类别</span>
            <span v-if="item.zjhtype == 1">居民证件号</span>
            <span v-else>其他证件号</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">证件号</span>
            <span>{{item.zjh}}</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">联系方式</span>
            <span>{{item.mobile}}</span>
          </div>
          <!-- <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">对接部门</span>
            <span>{{item.deptname}}</span>
          </div> -->
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">对接人</span>
            <span>{{item.contacts_username}}</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">是否驾车</span>
            <span>
              <span v-if="item.if_car == 1">是({{item.carinfo}})</span>
              <span v-else>否</span>
            </span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">来校原因</span>
            <span v-if="item.come_reason == 1">交流合作</span>
            <span v-else-if="item.come_reason == 2">招聘宣讲</span>
            <span v-else-if="item.come_reason == 3">送货维护</span>
            <span v-else>其他</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">具体事由</span>
            <span>{{item.come_for}}</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">出入有效期</span>
            <span>
              {{fnFormatTime(item.onshelves_time)}} 至 
              <span style="display: inline-block;">{{fnFormatTime(item.offshelves_time)}}</span>
            </span>
           
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">提交时间</span>
            <span>{{fnFormatTime(item.submit_time)}}</span>
          </div>
          <div class="card_list_info">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">当前进度</span>
            <span v-if="item.approval_status == 3 && item.s_approval_status == 3">
              待部门管理员审批
              <button @click="fnRevokeApproval(item.id,item.onshelves_time,item.offshelves_time)">撤回</button>
            </span>
            <span v-if="item.approval_status == 1 && item.s_approval_status == 3">
              待校级管理员审批
              <button @click="fnRevokeApproval(item.id,item.onshelves_time,item.offshelves_time)">撤回</button>
            </span>
            <span v-if="item.approval_status == 2 || item.s_approval_status == 2">
              已驳回
            </span>
            <span v-if="item.approval_status == 1 && item.s_approval_status == 1">
              已通过
            </span>
          </div>
          <div class="card_list_info" v-if="(item.approval_status == 2 || item.s_approval_status == 2) && item.refuse_reason">
            <span class="card_list_info_label" style="color:#939596;margin-right: 5px;">驳回理由</span>
            <span style="color:#e62525">
              {{item.refuse_reason}}
            </span>
          </div>
          <div class="card_list_info" style="text-align:right;display: block;" >
            <span style="color:orange;font-size: 12px;" v-if="item.approval_status == 3 || (item.s_approval_status == 3 && item.approval_status != 2)">{{fnFormatTime(item.submit_time)}} | 提交</span>
            <span style="color:#3370ff;font-size: 12px;" v-else-if="item.approval_status == 1 && item.s_approval_status == 1">{{fnFormatTime(item.s_approval_time)}} | 审批通过</span>
            <span style="color:#e62525;font-size: 12px;" v-else-if="item.approval_status == 2 || item.s_approval_status == 2">{{item.s_approval_time ? fnFormatTime(item.s_approval_time) : fnFormatTime(item.approval_time)}} | 驳回</span>
          </div>
        </div>
      </CellGroup>
      <div v-if="items.length === 0" style="text-align: center;margin-top: 20px;">暂无该证件号入校申请信息</div>
    </div>
  </div>
</template>

<script setup>
import fnGetData from '@/utils/request';
import {
  CellGroup, Button, showSuccessToast, showFailToast, showConfirmDialog, closeToast, showLoadingToast
} from 'vant';
import { onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
// 使用相对路径导入hash模块
import { generateHash, verifyDataIntegrity } from '../utils/hash';
const route = useRoute();
const getZjh = ref(route.params.zjh); //查询的证件号
const items = ref([]);
const loading = ref(true); // 加载状态管理
const currentTime = ref(new Date().toLocaleString()); // 实时时间戳

onMounted(() => {
  // 在组件挂载时将zjh保存到localStorage
  localStorage.setItem("zjh", getZjh.value);
  
  showLoadingToast({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
  });
  // 调用接口
  fnGetInfo();
  
  // 启动实时时间更新定时器
  const timer = setInterval(() => {
    currentTime.value = new Date().toLocaleString();
  }, 1000);
  
  // 实现页面完整性检查，防止控制台修改
  // 1. 使用MutationObserver监听DOM变化
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // 检查关键数据区域是否被修改
      if (mutation.target.className.includes('progress_popup')) {
        console.warn('检测到页面关键数据区域被修改，数据可能已被篡改！');
        // 可以在这里添加更严厉的措施，比如重新加载页面或显示警告
        showFailToast('检测到页面异常修改，请刷新页面重试');
      }
    });
  });
  
  // 配置观察选项
  const config = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
  };
  
  // 开始观察目标节点
  const targetNode = document.querySelector('.progress_all');
  if (targetNode) {
    observer.observe(targetNode, config);
  }
  
  // 2. 定期检查数据完整性，优化为30秒一次，平衡性能和安全性
  const integrityTimer = setInterval(() => {
    items.value.forEach((item, index) => {
      if (!verifyRecordIntegrity(item)) {
        console.warn(`定期检查发现记录 ${index + 1} 数据完整性验证失败！`);
        item._tampered = true;
      }
    });
  }, 30000); // 每30秒检查一次
  
  // 组件卸载时清除所有定时器和观察者
  onBeforeUnmount(() => {
    clearInterval(timer);
    clearInterval(integrityTimer);
    observer.disconnect();
  });
});

// 获取输入证件号相关申请信息
const fnGetInfo = () => {
  loading.value = true;
  fnGetData('/outschool/index/getInfo', { zjh: getZjh.value }, 30000, function(dataobj) {
    loading.value = false;
    closeToast();
    // 检查是否是错误信息字符串
    if (typeof dataobj === 'string' && dataobj.startsWith('err|')) {
      // 处理错误情况
      showFailToast('网络请求失败，请稍后重试');
      items.value = [];
      return;
    }
    // 检查dataobj是否包含data属性
    if (!dataobj || !dataobj.data) {
      showFailToast('获取数据失败，请稍后重试');
      items.value = [];
      return;
    }
    if (dataobj.data.status === 0) {
      // 为每条记录添加哈希值，用于数据完整性验证
      items.value = dataobj.data.data.map(item => {
        // 提取关键数据用于生成哈希，只包含必要字段
        const keyData = {
          id: item.id,
          approval_status: item.approval_status,
          s_approval_status: item.s_approval_status
        };
        // 生成哈希值
        const hash = generateHash(keyData);
        return {
          ...item,
          _hash: hash
        };
      });
    }
    else {
      showFailToast(dataobj.data.msg || '获取数据失败');
      items.value = [];
    }
  });
};

// 验证单条记录的数据完整性
const verifyRecordIntegrity = (record) => {
  // 提取关键数据用于验证，与生成哈希时的字段保持一致
  const keyData = {
    id: record.id,
    approval_status: record.approval_status,
    s_approval_status: record.s_approval_status
  };
  return verifyDataIntegrity(keyData, record._hash);
};

// 监听items变化，验证数据完整性
watch(items, (newItems) => {
  newItems.forEach((item, index) => {
    if (!verifyRecordIntegrity(item)) {
      console.warn(`记录 ${index + 1} 数据完整性验证失败，可能被篡改！`);
      // 可以在这里添加更明显的提示，比如标记该记录
      item._tampered = true;
    }
  });
}, { deep: true });

// 撤回入校申请
const fnRevokeApproval = (id, start, end) => {
  let startTime = fnFormatTime(start);
  let endTime = fnFormatTime(end);
  showConfirmDialog({
    title: '提示',
    message:
      `是否确认撤回入校有效期为 ${startTime} ~  ${endTime} 的申请？`,
  })
    .then(() => {
      // on confirm
      showLoadingToast({
        message: '处理中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      fnGetData('/outschool/index/revoke', {id: id}, 30000, function(dataobj) {
        closeToast();
        if (dataobj.data.status === 0) {
          showSuccessToast('撤回成功');
          fnGetInfo();
        }
        else {
          showFailToast(dataobj.data.msg);
        }
      });
    })
    .catch(() => {
      // on cancel
    });
};

// 时间格式化
const fnFormatTime = (time) => {
  let date = new Date(time*1000);
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  let hour = date.getHours().toString().padStart(2, '0');
  let minute = date.getMinutes().toString().padStart(2, '0');
  // let second = date.getSeconds().toString().padStart(2, '0');
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
}
</script>

<style scoped>
/* 页面背景水印，防止截图伪造 */
.progress_all{
  background-color: #d1c0ab;
  padding: 10px 0;
  /* 数字水印背景 */
  background-image: 
    linear-gradient(45deg, rgba(51, 112, 255, 0.05) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(51, 112, 255, 0.05) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgba(51, 112, 255, 0.05) 75%),
    linear-gradient(-45deg, transparent 75%, rgba(51, 112, 255, 0.05) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

/* 卡片样式，添加防篡改设计 */
.progress_all > .van-cell-group{
  /* 只设置背景色，不覆盖背景图片 */
  background-color: #e8e0d5;
  /* 移除CSS变量依赖，背景图片由内联样式控制 */
  position: relative;
  /* 防止卡片内容被轻松复制 */
  user-select: text !important;
  /* 添加轻微的纹理背景 */
  /* background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C92AC' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E"); */
}

/* 数据水印，为每条记录添加包含唯一标识符的背景水印 */
.progress_popup {
  /* 设置水印背景的重复模式，形成连续图案 */
  background-repeat: repeat;
  /* 调整水印尺寸，确保可见性 */
  background-size: 200px 100px;
  /* 调整水印位置，确保从角落开始平铺 */
  background-position: 0 0;
  /* 确保背景水印不影响内容可读性 */
  position: relative;
  overflow: visible;
  /* 确保卡片内容在水印上方 */
  z-index: 1;
}





/* 优化的水印效果，只使用::after伪元素创建多个重复水印 */
.progress_popup {
  /* 移除背景图像相关设置，只使用伪元素水印 */
  position: relative;
  overflow: visible;
  z-index: 1;
}

/* 移除旧的伪元素水印 */
.progress_popup::after {
  content: none;
}

/* 统一水印样式 - 提高可见性 */
.watermark {
  /* 水印文本样式 */
  font-size: 18px;
  font-weight: bold;
  font-family: Arial, sans-serif;
  /* 提高透明度和对比度，确保清晰可见 */
  color: rgba(22, 86, 255, 0.3);
  /* 确保水印在内容下方，但提高z-index确保不被其他元素覆盖 */
  z-index: 1;
  /* 禁止交互，不影响主要内容 */
  pointer-events: none;
  /* 确保水印在打印时可见 */
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
  /* 确保缩放时保持清晰度 */
  image-rendering: pixelated;
  /* 绝对定位，相对于父容器 */
  position: absolute;
  /* 文本不换行 */
  white-space: nowrap;
  /* 增强文本阴影，提高可见性 */
  text-shadow: 0 0 3px rgba(22, 86, 255, 0.2);
  /* 提高透明度，确保可见性 */
  opacity: 0.2;
}

/* 水印位置样式 - 9个均匀分布位置 */
.watermark-top-left {
  top: 10px;
  left: 10px;
  /* 不同旋转角度，增加视觉多样性 */
  transform: rotate(-15deg);
}

.watermark-top-center {
  top: 10px;
  left: 50%;
  /* 顶部居中定位 */
  transform: translate(-50%, 0) rotate(15deg);
}

.watermark-top-right {
  top: 10px;
  right: 10px;
  /* 不同旋转角度，增加视觉多样性 */
  transform: rotate(-15deg);
}

.watermark-middle-left {
  top: 33%;
  left: 10px;
  /* 左侧中间定位 */
  transform: rotate(-15deg);
}

.watermark-center {
  top: 50%;
  left: 50%;
  /* 居中定位 */
  transform: translate(-50%, -50%) rotate(-15deg);
  /* 中间水印稍微大一点 */
  font-size: 24px;
}

.watermark-middle-right {
  top: 66%;
  right: 10px;
  /* 右侧中间定位 */
  transform: rotate(-15deg);
}

.watermark-bottom-left {
  bottom: 10px;
  left: 10px;
  /* 不同旋转角度，增加视觉多样性 */
  transform: rotate(15deg);
}

.watermark-bottom-center {
  bottom: 10px;
  left: 50%;
  /* 底部居中定位 */
  transform: translate(-50%, 0) rotate(-15deg);
}

.watermark-bottom-right {
  bottom: 10px;
  right: 10px;
  /* 不同旋转角度，增加视觉多样性 */
  transform: rotate(15deg);
}

/* 确保卡片内容在水印上方，提高z-index */
.progress_popup > div:not(.watermark) {
  position: relative;
  z-index: 2;
}

/* 进度查询popup status */
.status_tip {
  position: absolute !important;
  right: 0 !important;
  border-radius: 0 8px !important;
  padding: 2px 15px !important;
  color: #fff !important;
  font-size: 12px !important;
}

/* 数据异常标签 */
.status_tip[style*='background:#ff0000'] {
  box-shadow: 0 0 10px rgba(255, 0, 0, 0.5) !important;
  animation: blink 1s infinite !important;
}

/* 闪烁动画，突出显示异常数据 */
@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0.7; }
}

/* card展示列表 */
.progress_popup:last-child {
  margin-bottom: 35px !important;
}

.progress_popup .card_list_info {
  text-align: left ;
  font-size: 14px ;
  margin-bottom: 6px ;
  width: 100% ;
  display: flex ;
  line-height: 1.4 ;
}

.progress_popup .card_list_info_label {
  color: #939596 !important;
  margin-right: 5px !important;
  display: inline-block !important;
  width: 6em !important;
}

/* 防止关键数据被轻松复制 */
.progress_popup .card_list_info span:not(.card_list_info_label) {
  /* 添加轻微的文本阴影，防止精确复制 */
  text-shadow: 0.5px 0.5px 0 rgba(0, 0, 0, 0.1) !important;
}



</style>